$(document).ready(function() {

mfpPopups();
megaMenu();


function megaMenu() {
  const $megaMenuMain = $("#site-header-mega-menu");
  if (!$megaMenuMain.length) return;
  const $desktopMM = $("#mega-menu-desktop");
  const $mobileMM = $("#mega-menu-mobile");
  if ($desktopMM.length) initDesktopMM();
  if ($mobileMM.length) initMobileMM();
  
  function initDesktopMM() {
    const $mainMenuItems = $desktopMM.find("[data-menu]");
    const $hisHerFilters = $desktopMM.find(".js-him-her-filter");
    const $hisHerFilterRemoveToggle = $desktopMM.find("[data-him-her-filter-remove-toggle]");
    const $filterLetterTriggers = $desktopMM.find(".js-filter-letter");
    const filterClasses = "active-filter--his active-filter--hers";
    const letterHideClass = "no-collections-available";

    //$mainMenuItems.on("click", ".js-toggle-mega-menu", activeItemMegaMenu);
    //$mainMenuItems.on("mouseout", deactivateMegaMenu);
    $hisHerFilters.on("click", hisHerFilterToggle);
    $hisHerFilterRemoveToggle.on("click", removeHisHerFilter);
    $filterLetterTriggers.on("click", scrollToLetterSection);

    function activeItemMegaMenu(e) {
      e.preventDefault();
      $(this).closest(".mega-menu-main-nav-item").toggleClass("active-mega-menu");
    }
    function deactivateMegaMenu(e) {
      $mainMenuItems.removeClass("active-mega-menu");
    }
    function hisHerFilterToggle(e) {
      e.preventDefault();
      const $this = $(this);
      const $parentMenuItem = $this.closest("li.mega-menu-main-nav-item");
      const thisFilter = $this.attr("data-filter").toLowerCase();
      const isAlreadyActive = $this.hasClass("active");

      $hisHerFilters.removeClass("active");
      $parentMenuItem.removeClass(filterClasses);
      if (!isAlreadyActive) {
        $this.addClass("active");
        $parentMenuItem.addClass(`active-filter--${thisFilter}`);
        hideNonMatchingCollections();
        $parentMenuItem.find(".mm-submenu-wrap").scrollTop(0);
      }
      else removeHisHerLetterFilter();

      function hideNonMatchingCollections() {
        $filterLetterTriggers.each((i,el) => {
          const $this = $(el);
          const $collectionGroup = $($this.attr("href"));
          if (!$collectionGroup.length) return;
          else {
            // reset hide classes
            $this.removeClass(letterHideClass);
            $collectionGroup.removeClass(letterHideClass);
          }
          const $visibleCollections = $collectionGroup.find(".brand-collection-item:visible");
          if (!$visibleCollections.length) {
            // hide letter and collection group
            $this.addClass(letterHideClass);
            $collectionGroup.addClass(letterHideClass);
          }
        });
      }
    }
    function removeHisHerFilter(e) {
      e.preventDefault();
      const $parentMenuItem = $(this).closest("li.mega-menu-main-nav-item");
      $hisHerFilters.removeClass("active");
      $parentMenuItem.removeClass(filterClasses);
      removeHisHerLetterFilter();
      $parentMenuItem.find(".mm-submenu-wrap").scrollTop(0);
    }
    function removeHisHerLetterFilter() {
      $filterLetterTriggers.removeClass(letterHideClass);
      $desktopMM.find(".brand-collection-group").removeClass(letterHideClass);
    }
    function scrollToLetterSection(e) {
      e.preventDefault();
      const $this = $(this);
      const $parentMenuItem = $this.closest("li.mega-menu-main-nav-item");
      const $target = $($this.attr("href"));
      if (!$target.length) return;
      $parentMenuItem.find(".mm-submenu-wrap").animate({
        scrollTop: $target.position().top
      }, 300);
    }
  }

  function initMobileMM() {
    const $mainMenuItems = $mobileMM.find("[data-menu]");
    const $returnToMainNavTrigger = $mobileMM.find(".js-back-to-main-nav");
    const $menuItemMegaMenuTrigger = $mobileMM.find(".js-brands-mm-toggle");
    const $himHerFilterTriggers = $mobileMM.find(".js-him-her-filter");
    const $returnToSubmenuTrigger = $mobileMM.find(".js-return-to-submenu");
    const $filterLetterDropdown = $mobileMM.find(".js-filter-letter");
    const $panelOverlay = $mobileMM.find(".drawer-menu__overlay");
    const parentMenuClass = "li.mobile-mm-main-nav-item";
    const activeClasses = { megaMenuSubmenu: "has-active-submenu", megaMenuMM: "has-active-mega-menu", mainMenuItemSubmenu: "active", mainMenuItemMM: "active-mega-menu", hisHers: "active-filter--his active-filter--hers" };

    $returnToMainNavTrigger.on("click", returnToMainNav);
    $mainMenuItems.on("click", ".js-mobile-submenu-trigger", toggleSubmenu);
    $menuItemMegaMenuTrigger.on("click", toggleMegaMenu);
    $returnToSubmenuTrigger.on("click", returnToSubmenu);
    $filterLetterDropdown.on("change", filterBrandsByLetter);
    $himHerFilterTriggers.on("click", hisHerFilterItems);
    $panelOverlay.add($mobileMM.find("button.drawer-menu__close-icon")).on("click", removeAllFiltersAndClasses);


    function returnToMainNav(e) {//console.log("return to main nav");
      e.preventDefault();
      $mobileMM.removeClass(activeClasses.megaMenuSubmenu).removeClass(activeClasses.megaMenuMM);
      $mainMenuItems.removeClass(activeClasses.mainMenuItemSubmenu).removeClass(activeClasses.mainMenuItemMM).removeClass(activeClasses.hisHers);
      removeHisHerLetterFilter();
    }
    function toggleSubmenu(e) {//console.log("toggle submenu");
      e.preventDefault();
      const $this = $(this);
      const $parentMenuItem = $this.closest(parentMenuClass);
      $mobileMM.addClass(activeClasses.megaMenuSubmenu);
      $parentMenuItem.addClass(activeClasses.mainMenuItemSubmenu);
    }
    function toggleMegaMenu(e) {//console.log("toggle mega menu")
      e.preventDefault();
      const $this = $(this);
      const $parentMenuItem = $this.closest(parentMenuClass);
      $mobileMM.addClass(activeClasses.megaMenuMM);
      $parentMenuItem.removeClass(activeClasses.hisHers);
      $parentMenuItem.addClass(activeClasses.mainMenuItemMM);
      $parentMenuItem.attr("data-active-letter", "");
    }
    function hisHerFilterItems(e) {
      e.preventDefault();
      const $this = $(this);
      const $parentMenuItem = $this.closest(parentMenuClass);
      const thisFilter = $this.attr("data-filter").toLowerCase();
      $parentMenuItem.addClass(`active-filter--${thisFilter}`);
      filterLetterOptions();

      function filterLetterOptions() {
        const $navLetterFilterDropdown = $parentMenuItem.find(".js-filter-letter");
        const $navCollectionGroups = $parentMenuItem.find(".mobile-brand-collection-group");

        $navLetterFilterDropdown.find("option").each((i,el) => {
          const $this = $(el);
          const letter = $this.attr("value");
          const $matchingCollectionGroup = $navCollectionGroups.filter(`[data-letter="${letter}"]`);
          if (!$matchingCollectionGroup.length) return;
          const $visibleCollections = $matchingCollectionGroup.find(".brand-collection-item:visible");
          if (!$visibleCollections.length) $this.addClass("no-collections-available");
        });
      }
    }
    function removeHisHerLetterFilter() {
      $filterLetterDropdown.find("option").removeClass("no-collections-available");
    }
    function returnToSubmenu(e) {//console.log("return to submenu");
      e.preventDefault();
      const $this = $(this);
      const $parentMenuItem = $this.closest(parentMenuClass);
      const $activeLetterLabel = $parentMenuItem.find(".js-active-letter-label");
      $mobileMM.removeClass(activeClasses.megaMenuMM);
      $parentMenuItem.removeClass(activeClasses.hisHers).removeClass(activeClasses.mainMenuItemMM);
      $parentMenuItem.attr("data-active-letter", "");
      $activeLetterLabel.text("A");
      removeHisHerLetterFilter();
    }
    function filterBrandsByLetter(e) {//console.log("filter brands by letter");
      e.preventDefault();
      const $this = $(this);
      const $parentMenuItem = $this.closest(parentMenuClass);
      const activeLetter = $this.val();
      const $activeLetterLabel = $parentMenuItem.find(".js-active-letter-label");
      const activeLetterLabel = (activeLetter === "") ? "A" : activeLetter;
      $parentMenuItem.attr("data-active-letter", activeLetter);
      $activeLetterLabel.text(activeLetterLabel);
      $mobileMM.find(".drawer-menu__panel").scrollTop(80);
    }
    function removeAllFiltersAndClasses(e) {
      $mobileMM.removeClass(activeClasses.megaMenuSubmenu).removeClass(activeClasses.megaMenuMM);
      $mainMenuItems.removeClass(activeClasses.mainMenuItemSubmenu).removeClass(activeClasses.mainMenuItemMM).attr("data-active-letter","");
      $filterLetterDropdown.each((i,el) => { $(el).val("") });
      removeHisHerLetterFilter();
      $mobileMM.find(".js-active-letter-label").text("A");
    }
  }
}


function mfpPopups() {
  const $mfpTriggers = jQuery(".js-mfp-trigger");
  if (!$mfpTriggers.length) return;
  loadStyle("https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/magnific-popup.min.css");
  loadScript("https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/jquery.magnific-popup.min.js", init);

  
  function init() {console.log("mfp loaded");
    $mfpTriggers.each(_init);

    function _init(i, mfpTrigger) {
      const $this = $(mfpTrigger);
      if ($this.hasClass("js-mfp-inline")) {
        $this.magnificPopup({
          type: "inline",
          midClick: true,
        });
      }

      const $target = $($this.attr("href"));
      if (!$target.length) return;
      if ($target.find(".shopify-message").length || $target.find(".shopify-error").length) $this.trigger("click");
    }
  }
}


/* Helpers */
function loadScript(url, callback = false) {
    var script = document.createElement("script");

    script.type = "text/javascript";
    //IE
    if (script.readyState){
        script.onreadystatechange = function(){
            if (script.readyState == "loaded" || script.readyState == "complete"){
                script.onreadystatechange = null;
                onload();
            }
        };
    }
    else {
        script.onload = function(){
            onload();
        };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);

    function onload() {
        if (callback != false) { callback(); }
    }
}
function loadStyle(url, callback = false) {
    var style = document.createElement("link");

    style.rel = "stylesheet";
    //IE
    if (style.readyState){
        style.onreadystatechange = function(){
            if (style.readyState == "loaded" || style.readyState == "complete"){
                style.onreadystatechange = null;
                onload();
            }
        };
    }
    else {
        style.onload = function(){
            onload();
        };
    }
    style.href = url;
    document.getElementsByTagName("head")[0].appendChild(style);

    function onload() {
        if (callback != false) { callback(); }
    } 
}

/**** PREVIOUS THEME CODE ***/
var gmapsInit = (function () {
    $(".gecko-gmap").each(function (index) {
       var $this = $(this),
          lat = $this.data('lat'),
          lon = $this.data('lon'),
          icon = $this.data('icon'),
          style = $this.data('style');
       new Maplace({
          locations: [{
             lat: lat,
             lon: lon,
             title: '',
             html: '',
             icon: icon,
             animation: google.maps.Animation.DROP
          }],
          controls_on_map: false,
          title: '',
          map_div: $this,
          start: 1,
          map_options: {
             zoom: 15,
             scrollwheel: false
          },
          styles: {
             'Custom style': style
          }
       }).Load();
    });
})();

//-------------------- Brand Partners
$(document).on('click', '.bp-menu-link', function(e){
  e.preventDefault();
  $('.bp-menu-link').removeClass('active');
  $(this).addClass('active');
  
  $('.brandpartner-block').removeClass('empty');
  
  var value = $(this).data('value');
  if (value.localeCompare('all') == 0) {
    $('.brandpartner-block h3').removeClass('hide');
  }
  else {
    $('.brandpartner-block h3').each(function(){
      $(this).removeClass('hide');

      var show = $(this).data(value);
      if (!show) {
        $(this).addClass('hide');
      }
    })
  }
  
  $('.brandpartner-block').each(function() {
    if ($(this).find('h3:not(".hide")').length == 0) {
      $(this).addClass('empty');
    }
  });
  
});

  
if ($('.brandpartner-block').length > 0) {
  $('.brandpartner-block').each(function() {
    if ($(this).find('h3:not(".hide")').length == 0) {
      $(this).addClass('empty');
    }
  });
}
  

//-------------------- Teak Tearoom Menu
$(document).on('click', '.ttm-menu-link', function(e){
  e.preventDefault();
  $('.ttm-menu-link').removeClass('active');
  $(this).addClass('active');
  
  $('.brandpartner-block').removeClass('empty');
  
  var value = $(this).data('value');
  
    $('.ttm-block').each(function(){
      $(this).removeClass('hide');

      var show = $(this).data(value);
      if (!show) {
        $(this).addClass('hide');
      }
    })
});


if ($('.ttm-menu-link.active').length > 0) {
  var value = $('.ttm-menu-link.active').data('value');

  $('.ttm-block').each(function(){
    $(this).removeClass('hide');

    var show = $(this).data(value);
    if (!show) {
      $(this).addClass('hide');
    }
  })
}
  
  

//--------------------------- Career Page
$('.btn_cv').on('click', function(e) {
  e.preventDefault();
  $('#career_cv').trigger('click');
});



});